// extracted by mini-css-extract-plugin
export default {"title":"Summary_title__bvu6R","info":"Summary_info__ulRm7","links":"Summary_links__KrUiX","image":"Summary_image__38Xi8","linkTitle":"Summary_linkTitle__lWFKy"};